import { useMutation, useQueryClient } from '@tanstack/react-query';

import { displayToastError } from '@/helpers/display-toast';
import { useApiError } from '@/modules/common/hooks/use-api-error';
import { invalidateSeniorityRelatedQueries } from '@/modules/common/utils/query-invalidation';
import { deleteSeniority } from '@/modules/settings/api/seniorities.api';

/**
 * Hook to delete a seniority.
 * Handles mutation, cache invalidation for seniorities and related team member queries.
 *
 * @returns TanStack Query mutation for deleting a seniority
 */
export const useDeleteSeniorities = () => {
  const queryClient = useQueryClient();
  const { getErrorMessage } = useApiError();

  return useMutation({
    mutationFn: deleteSeniority,
    onSuccess: async () => {
      // Invalidate seniority and team member queries
      await invalidateSeniorityRelatedQueries(queryClient);
    },
    onError: (error: unknown) => {
      displayToastError(getErrorMessage(error, true));
    },
  });
};
